export default "__VITE_ASSET__BlAe6d6O__"